export interface ImageDesc { name: string, title: { de: string; en: string }, image: string, format: string, versionNr: string };

export const itemDataAll = [
    {
        name: "Serie_Zauberfloete",
        title: {
            "de": "Die Zauberflöte",
            "en": "The Magic Flute"
        },
        image: "small/Koenigin_der_Nacht",
        format: "portrait",
        versionNr: "0"
    },
    {
        name: "Serie_AdamUndEva",
        title: {
            "de": "Adam und Eva",
            "en": "Adam and Eve"
        },
        image: "small/Adam_und_Eva4",
        format: "portrait",
        versionNr: "0"
    },
    {
        name: "Serie_Exlibris",
        title: {
            "de": "Exlibris",
            "en": "Ex Libris"
        },
        image: "small/Hamlet",
        format: "landscape",
        versionNr: "0"
    },
    {
        name: "Serie_Zirkus",
        title: {
            "de": "Zirkus",
            "en": "In the Circus"
        },
        image: "small/Zirkus4",
        format: "portrait",
        versionNr: "0"
    },
    {
        name: "Serie_Augustin",
        title: {
            "de": "Der Liebe Augustin",
            "en": "Dear Augustine"
        },
        image: "small/Augustin2",
        format: "portrait",
        versionNr: "0"
    },
    {
        name: "Serie_Heilige",
        title: {
            "de": "Heilige",
            "en": "Saints"
        },
        image: "small/Heiliger_Nepomuk",
        format: "portrait",
        versionNr: "0"
    },
    {
        name: "Serie_Pinocchio",
        title: {
            "de": "Pinocchio",
            "en": "Pinocchio"
        },
        image: "small/PinocchioDante3",
        format: "landscape",
        versionNr: "0"
    },
    {
        name: "Serie_Bibel",
        title: {
            "de": "Biblisches",
            "en": "From the Bible"
        },
        image: "small/Arche_Noah1",
        format: "landscape",
        versionNr: "0"
    },
    {
        name: "Serie_Buchstaben",
        title: {
            "de": "Buchstäbliches",
            "en": "Literally"
        },
        image: "small/Buchstabe_M",
        format: "portrait",
        versionNr: "0"
    },
    {
        name: "Serie_Babylon",
        title: {
            "de": "Vermischtes",
            "en": "Miscellaneous"
        },
        image: "small/Mondphasen",
        format: "portrait",
        versionNr: "0"
    }
];